import React from 'react';
import { Modal, Table } from 'react-bootstrap';
import IconButton from '../common/IconButton';
import './ContactSupportMessage.css'

interface IProps {
    showContactSuportMessage: boolean;
    setShowContactSuportMessage: Function;
    openContactSupportMessage: Function;
}

type SupportType = {
    label: string
    value: string | number | undefined;
}

const ContactSupportMessage: React.FC<IProps> = (props) => {
    //r-18-lint-cm
    //eslint-disable-next-line
    const { showContactSuportMessage, setShowContactSuportMessage, openContactSupportMessage } = props;
    const supportItems: Array<SupportType> = [
        { label: "Support Email", value: process.env.REACT_APP_USER_SUPPORT_EMAIL },
        { label: "Support Phone", value: process.env.REACT_APP_USER_SUPPORT_PHONE },
    ];

    return (
        <Modal dialogClassName='contact-support-message-modal' show={showContactSuportMessage} centered>
            <Modal.Header>
                <h3>Contact Support</h3>
            </Modal.Header>
            <Modal.Body>
                <p>Request is out of sync with time entry.  Contact User Support.</p>
                <Table>
                    <tbody>
                        {supportItems.map((item: SupportType, index: number) => (
                            <tr key={index}>
                                <td className='font-weight-bold'>{item.label}</td>
                                <td>{item.value}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <IconButton onClick={() => openContactSupportMessage()} buttonClassName="action-text-danger" icon="close">Close</IconButton>
            </Modal.Footer>
        </Modal>
    )
}
export default ContactSupportMessage;

